import { render, staticRenderFns } from "./CarouselProducts.vue?vue&type=template&id=38a0b088&"
import script from "./CarouselProducts.vue?vue&type=script&lang=js&"
export * from "./CarouselProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports